// eslint-disable-next-line no-unused-vars
import Service from "../../Services";
import Swal from "sweetalert";
const Login = {
  namespaced: true,
  state: {
    isLogin: false,
    token: null,
    accessToken : null,
    userDetail: null,
    rolePermission : [],
  },
  mutations: {
    SET_LOGIN(state, data) {
      state.token = data;
    },
    SET_USER_DETAIL(state, data) {
      state.isLogin = true;
      state.userDetail = data;
      state.rolePermission = data.role ? data.role.permission : [];
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    get({ commit }, page) {},
    // eslint-disable-next-line no-unused-vars
    show({ commit }, id) {},
    // eslint-disable-next-line no-unused-vars
    save({ commit }, { id, data }) {
      // eslint-disable-next-line no-empty
      if (id) {
        // eslint-disable-next-line no-empty
      } else {
      }
    },
    // eslint-disable-next-line no-unused-vars
    delete({ commit }, id) {},
    onLogin({ commit }, data) {
      return Service.AuthAPI.onLogIn(data).then((res) => {
        if (res.status === 'success') {
          commit('SET_LOGIN', res.result);
          return res.result
        }
      })
    },
    onUserLoginWithGoogle({ commit }, data) {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('result')) {
        commit('SET_LOGIN', data);
        console.log('Login success!')
      } else {
        alert('ไม่สามารถยืนยันตัวตนได้');
      }
    },
    onUserLogOut({ commit }, token) {
      return Service.AuthAPI.onLogOut(token).then(() => {
        // reload page after logged out
        window.location.reload();
        // clear local storage
        window.localStorage.removeItem('vuex');

      });
    },
    onGetUserDetail({ commit }, data) {
      return Service.AuthAPI.getUserDetail(data).then((res) => {
        commit('SET_USER_DETAIL', res);
      });
    },
  },
};
export default Login;
